export default {"src":"/_next/static/media/loading.f83c750c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};